export { FlexibleColumnFAQs } from './FlexibleColumnFAQs';
export { FAQs } from './FAQs';
export { FAQFormattedAnswer } from './FAQFormattedAnswer';
export type { QuestionAnswerProps } from './FAQs';
